// 鉴权相关状态码
const ERRNO_LIST_AUTH = [
    401,
    403,
    406,
];

// 教育模式不可访问错误码
const ERRNO_EDUCATION_BANNED = 455;

// 助手下线错误码
const ERRNO_LIST_ASSISTANT_OFFLINE = 419;

// 话题下线错误码
const ERRNO_LIST_TOPIC_OFFLINE = 430;

/**
 * 需要通知端处理的状态码
 */
const ERRNO_LIST_NA = [
    ...ERRNO_LIST_AUTH,
    ERRNO_LIST_ASSISTANT_OFFLINE,
    ERRNO_LIST_TOPIC_OFFLINE,
    410,
];

/**
 * 命中反作弊状态码
 */
const ERRNO_LIST_ANTI = [511];
const COIN_NOT_ENOUGH_ERRNO = 517;
const COIN_DAY_PAY_OVERDUE_ERRNO = 414;
const MEMBER_FREE_ERRNO = 420;
/**
 * 特殊prompt发送消息不合规，(例如图生文prompt内，发送非图片消息)
 * 512 - 例如图生文prompt内，发送非图片消息
 * 517 - 灵感币不足，errmsg为：**抱歉，你当前灵感币不足**\n[点击参与任务，获取更多灵感币→](/talk/cointask)
 * 418 - 端外聊天次数不足或者收费或图片等不支持场景的错误提示
 */
const ERRNO_LIST_PROMPT = [
    416,
    418,
    512,
    COIN_NOT_ENOUGH_ERRNO,
    COIN_DAY_PAY_OVERDUE_ERRNO,
];

/**
 * 一言限流状态码
 */
const ERRNO_LIST_LIMIT = [513];

/**
 * 一言限流状态码
 */
const ERRNO_LIST_VS = [515];

/**
 * 上屏检查未通过状态码
 */
const SCREEN_CHECK_ERRNO = 454;
/**
 * 需要处理的非0状态码
 */
const ERRNO_LIST = [
    ...ERRNO_LIST_NA,
    ...ERRNO_LIST_ANTI,
    422, // 深度搜索命中风控情况
    452,
    453,
    SCREEN_CHECK_ERRNO,
    509,
    510,
    512, // 图生文二级页发纯文本
];

// 无效内容
const ERRNO_OUTLINE_INVALID_CONTENT = 810;

// 大纲已被删除
const ERRNO_OUTLINE_INVALID = 812;

// 大纲格式错误
const ERRNO_OUTLINE_FORMAT_ERROR = 811;

// 风险审核失败
const ERRNO_RISK_AUDIT_FAILED = 818;

export {
    COIN_DAY_PAY_OVERDUE_ERRNO,
    COIN_NOT_ENOUGH_ERRNO,
    ERRNO_EDUCATION_BANNED,
    ERRNO_LIST,
    ERRNO_LIST_ANTI,
    ERRNO_LIST_ASSISTANT_OFFLINE,
    ERRNO_LIST_AUTH,
    ERRNO_LIST_LIMIT,
    ERRNO_LIST_NA,
    ERRNO_LIST_PROMPT,
    ERRNO_LIST_TOPIC_OFFLINE,
    ERRNO_LIST_VS,
    MEMBER_FREE_ERRNO,
    SCREEN_CHECK_ERRNO,
    ERRNO_OUTLINE_INVALID_CONTENT,
    ERRNO_OUTLINE_INVALID,
    ERRNO_OUTLINE_FORMAT_ERROR,
    ERRNO_RISK_AUDIT_FAILED,
};
